// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"411ded9f","437":"e2a0412b","548":"ddd0cea7","616":"9541e71c"}[chunkId] + ".chunk.js";
};